jQuery($ => {
  class Drawer {
    constructor(element, args = {}) {
      this._            = element;
      this._element     = $(element);
      this._closeButton = this._element.find('.m-drawer__close');
      this._overlay     = this._element.find('.m-drawer__overlay');
      this._focusable   = this._element.find(
        'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      this._closeOnClickout = this._element.data('clickoutclose');

      this._args = $.extend({
        triggerId: this._element.data('controlledby'),
        focusOnDrawer: false
      }, args);

      this._trigger = $(`#${this._args.triggerId}`);

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._closeButton.on('click', this.handleCloseButtonClick);
      this._overlay.on('click', this.handleOverlayClick);
      this._element.on('keydown', this.handleKeydown);

      if (this._closeOnClickout) {
        $(document).on('click', this.handleOutsideClick);
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Open
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleOpen = () => {
      if (this._element.hasClass('m-drawer--open')) return;

      this._element
        .addClass('m-drawer--open')
        .attr('tabindex', '1');
      
      if ( this._closeButton[0] ) {
        setTimeout(() => {
          this._closeButton.focus();
        }, 100);
      }

      this._element.trigger('open', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Close
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleClose = () => {
      if (!this._element.hasClass('m-drawer--open')) return;

      this._element
        .removeClass('m-drawer--open')
        .attr('tabindex', '-1');

      if (this._trigger[0]) {
        this._trigger
          .removeClass('m-drawer-trigger--open')
          .focus();
      }

      this._element.trigger('close', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Clicking Outside Drawer
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleOutsideClick = event => {
      if (!this._.contains(event.target)) {
        if (this._trigger[0] && this._trigger[0].contains(event.target)) return;

        this.handleClose();
        this._element.trigger('clickoutClose', this);
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleKeydown = event => {
      switch (event.key) {
        case 'Tab':
          const $firstFocusable = this._focusable[0];
          const $lastFocusable = this._focusable[this._focusable.length - 1];

          if (
            ($(event.target).is($lastFocusable) && !event.shiftKey) ||
            ($(event.target).is($firstFocusable) && event.shiftKey)
          ) {
            event.preventDefault();

            if ($(event.target).is($lastFocusable)) {
              $firstFocusable.focus();
            } else {
              $lastFocusable.focus();
            }
          } else if ($(event.target).is(".m-drawer")) {
            event.preventDefault();

            $firstFocusable.focus();
          }
          break;

        case 'Escape':
        case 'Esc':
          this.handleClose();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Close Button Click
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleCloseButtonClick = () => {
      this.handleClose();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Overlay Click
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleOverlayClick = () => {
      this.handleClose();
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.drawer = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].drawer = new Drawer(_[i], opt);
      else
        ret = _[i].drawer[opt].apply(_[i].drawer, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-drawer').drawer();
});